import React from 'react';
import Img from 'gatsby-image';

import {Row, Column} from '../../global/grid/grid';
// import Image from '../../global/media/Image';

import { QuoteWrapper, Statement, Attribution, QuoteModule } from './styled-components';

const Quote = ({data, imageDictionary}) => {
  if(!data.withImage) {
    return (
      <QuoteModule>
          <Row style={{ alignItems: 'center' }}>
            <QuoteWrapper cw={8} offset={2} color={data.color}>
              <Statement color={data.color}>{data.quote}</Statement>
              <Attribution>{data.attribution}</Attribution>
            </QuoteWrapper>
          </Row>
      </QuoteModule>
    )
  } else {
    if(data.direction === 'left'){
      return (
        <QuoteModule>
            <Row>
              <QuoteWrapper cw={7} offset={1} color={data.color}>
                <Statement color={data.color}>{data.quote}</Statement>
                <Attribution>{data.attribution}</Attribution>
              </QuoteWrapper>
              <Column className="imageColumn" cw={4}>
                <Img sizes={imageDictionary[data.image].sizes} />
              </Column>
            </Row>
        </QuoteModule>
      )
    } else {
      return (
        <QuoteModule>
            <Row>
              <Column className="imageColumn" cw={4}>
                <Img sizes={imageDictionary[data.image].sizes} />
              </Column>
              <QuoteWrapper cw={7} offset={1} color={data.color}>
                <Statement color={data.color}>{data.quote}</Statement>
                <Attribution>{data.attribution}</Attribution>
              </QuoteWrapper>              
            </Row>
        </QuoteModule>
      )
    }
  }
}

export default Quote;



// WEBPACK FOOTER //
// ./src/components/modules/Quote/Quote.js